import axios from '../axios';

export default {
  getComplex () {
    return new Promise((resolve, reject) => {
      axios.get('/residential-complex')
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  createComplex (params) {
    return new Promise((resolve, reject) => {
      axios.post('/residential-complex', params)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  viewComplex (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/residential-complex/${id}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  updateComplex (id, value) {
    return new Promise((resolve, reject) => {
      axios.put(`/residential-complex/${id}`, value)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  deleteComplex (id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/residential-complex/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
};
